<template>
  <div class="container">
    <div class="wait-screen-reviews">
      <h2 class="wait-screen-reviews__title">
        Our <span :class="textColorClass()">Proud</span> Customers.
      </h2>
      <AppSlider
        class="my-20"
      >
        <ReviewCard
          v-for="(review, index) in cmsReviews"
          :key="`review-${index}`"
          :avatar="review.avatar"
          :name="review.name"
          :benefit-value="review.benefit_value"
          :review-quote="review.review_quote"
          :address="review.address"
          :category-id="review.category_id"
        />
      </AppSlider>
    </div>
    <div class="wait-screen-reviews__trustpilot">
      <h2 class="container text-3xl mb-30 text-left sm:text-center">
        <span class="inline-block">The most convenient financial solution in Canada</span>
        <span class="text-pinegreen inline-block">
          with over $500 million in loans funded to our customers &nbsp;
        </span>
        <span class="inline-block">since 2016.</span>
      </h2>
      <div class="mb-60">
        <div class="text-center w-full container">
          <span class="font-bold text-lg mr-10">Excellent</span>
          <img
            v-for="index in 5"
            :key="`star-${index}`"
            :src="trustpilot_star_square"
            class="inline h-20 w-20 mr-[2px]"
            alt="Trustpilot start"
          >
          <span class="font-bold">&nbsp;10,716</span>
          &nbsp;reviews on
          <img
            :src="trustpilot_star"
            class="h-20 inline mt-[-5px]"
          >
          <span class="font-bold">&nbsp;Trustpilot</span>
        </div>
      </div>

      <AppSlider
        class="text-center my-20"
        theme="green"
      >
        <TrustPilotCard
          v-for="(review, index) in trustpilotReviews"
          :key="`review-${index}`"
          :title="review.title"
          :content="review.content"
          :footer="review.footer"
        />
      </AppSlider>
    </div>

    <AppOverview :lottie-data="foundationLottie">
      <h2 class="mb-20 md:mb-0">
        <span class="text-purple-500">Financing</span><br>on the Go.
      </h2>
      <p>We don’t believe in line ups! At Spring, all of our products can be accessed from anywhere. Whether you are on your phone or your computer, we bring the funding to you.</p>
    </AppOverview>

    <AppOverview
      is-reverse
      :lottie-data="evergreenLottie"
    >
      <h2 class="mb-20 md:mb-0">
        Next Gen <span class="text-green-500"><br>Financing.</span>
      </h2>
      <p>Spring’s intelligent application system assesses a wide variety of data in order to get you the best-fit financial product in just a few minutes, when it could normally take up to a few weeks.</p>
    </AppOverview>
  </div>
</template>

<script>
import theme from '@/mixins/theme'
import ReviewCard from './ReviewCard.vue'
import TrustPilotCard from './TrustPilotCard.vue'
import AppSlider from '@/components/common/slider/AppSlider'
import AppOverview from '@/components/steps/wait-screen/AppOverview'

export default {
  name: 'WaitScreenReviews',
  components: {
    ReviewCard,
    TrustPilotCard,
    AppSlider,
    AppOverview
  },
  mixins: [theme],
  data () {
    return {
      trustpilot_star_square: require('@/assets/svg/trustpilot_star_square.svg'),
      trustpilot_star: require('@/assets/svg/trustpilot_star.svg'),
      cmsReviews: require('@/assets/testimonials/cms.json'),
      trustpilotReviews: require('@/assets/testimonials/trustpilot.json'),
      foundationLottie: require('@/assets/lottie/delay/foundation.json'),
      evergreenLottie: require('@/assets/lottie/delay/evergreen.json'),
      carouselSettings: {
        'infinite': true,
        'slidesToShow': 3,
        'swipeToSlide': true,
        'edgeFriction': 0,
        'accessibility': true,
        'centerMode': false,
        'responsive': [
          {
            'breakpoint': 1366,
            'settings': {
              'slidesToShow': 2
            }
          },
          {
            'breakpoint': 768,
            'settings': {
              'slidesToShow': 1,
              'centerMode': true
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wait-screen-reviews {
  @apply mx-auto text-center;

  &__title {
    @apply text-3xl mb-30 text-center;
  }

  &__trustpilot {
    @apply mb-30;

    &-title {
      @apply mb-30;
    }
  }
}
</style>
